import API from "@/api";

export default {
	api: API.system.upload,			//上传请求API对象
	filename: "file",					//form请求时文件的key
	successCode: 0,					//请求完成代码
	maxSize: 10,						//最大文件大小 默认10MB
	parseData: function (res) {
		return {
			fileName: res.fileName,
			src: res.filePath,
		}
	}
}
